export default __webpack_public_path__ + "static/media/P1000-Tip-Solution.4001b8ef.svg";